import { Link, usePage } from '@inertiajs/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import menuboiler from '../../images/menu-boiler.jpg';
import { useEffect, useState } from 'react';

function NavMenu({ menuOpen, setMenuOpen }: { menuOpen: boolean; setMenuOpen: React.Dispatch<React.SetStateAction<boolean>> }) {
   const { menu } = usePage().props as any;
   const headerMenu = menu.find((m: any) => m.name === 'main menu');
   const menuItems = headerMenu?.items || [];
   const menuTree = menuItems;

   const [activeMenu, setActiveMenu] = useState(null);
   const [openedMenu, setOpenedMenu] = useState<string | null>(null);


   return (
      <>
         <div className="header-below">
            <div className="container">
               <div className="header-item item-center">
                  <div className={`menu-overlay ${menuOpen ? 'active' : ''}`}></div>
                  <nav className={`menu ${menuOpen ? 'active' : ''}`}>
                     <div className={`mobile-menu-head ${openedMenu === 'null' ? '' : 'active'}`}>
                        <div className="go-back" onClick={() => setOpenedMenu(null)}><FontAwesomeIcon icon={faAngleLeft} /></div>
                        <div className="current-menu-title">{openedMenu}</div>
                        <div className="mobile-menu-close" onClick={() => setMenuOpen(false)}>&times;</div>
                     </div>
                     <ul className='menu-main'>
                        {menuTree.map((item: any, index: number) => {
                           if (!item.children || item.children.length === 0) {

                              return (
                                 <li key={`${item.label}-${index}`}>
                                    <Link href={`/${item.url || "/"}`} className='' onClick={() => setMenuOpen(false)}>
                                       {item.label}
                                    </Link>
                                 </li>
                              );

                           }

                           return <MegaMenu key={`${item.label}-${index}`} item={item} setActiveMenu={setOpenedMenu} activeMenu={openedMenu} setOpenMenu={setMenuOpen} />;
                        })}
                     </ul>
                  </nav>
               </div>
            </div>
         </div>
      </>
   )
}

const MegaMenu = ({ item, setActiveMenu, activeMenu, setOpenMenu }: { item: any; setActiveMenu: any; activeMenu: any, setOpenMenu: any }) => {
   const columns = splitIntoColumns(item.children, 2);
   const [clicked, setClicked] = useState(false);

   useEffect(() => {
      const debounceTimer = setTimeout(() => {
         if (clicked) {
            setClicked(false);
         }
      }, 1000);

      return () => clearTimeout(debounceTimer);
   }, [clicked]);

   const acsNavMenuClick = () => {
      setClicked(true);
      setOpenMenu(false);
   }

   return (
      <li className={`menu-item-has-children ${clicked ? 'clicked' : ''}`}>
         <Link href={`/${item.url || "#"}`}>
            {item.label}
            <i
               className="fa fa-angle-down"
               onClick={(e) => {
                  e.preventDefault();
                  setActiveMenu(activeMenu === item.label ? null : item.label);
               }}
            ></i>
         </Link>
         <div className="menu-title d-flex justify-content-between align-items-center">

         </div>
         {item.label === 'Boilers' ? (
            <div className={`sub-menu mega-menu mega-menu-column-4 ${activeMenu === item.label ? 'active' : ''}`}>
               {columns.map((col: any, i: number) => (
                  <div className="list-item" key={`group-${i}`}>

                     {col.map((section: any, index: number) => (
                        <div key={`section-${section.label}-${index}`} className='m-0 p-0'>
                           <h4 className="title">{section.label}</h4>

                           <ul>
                              {section.children.map((child: any, j: number) => (
                                 <li key={`child-${child.label}-${j}`}>
                                    <Link href={`/${child.url || "#"}`} onClick={acsNavMenuClick}>
                                       {child.label}
                                    </Link>
                                 </li>
                              ))}
                           </ul>
                        </div>
                     ))}

                  </div>
               ))}
               <div className="list-item">
                  <img src={menuboiler} alt="Boiler" />
               </div>
            </div>
         ) : (
            <div className={`sub-menu single-column-menu ${activeMenu === item.label ? 'active' : ''}`}>
               <ul>
                  {item.children?.map((col: any, index: number) => (
                     <li key={index}>
                        <Link href={`/${col.url || "#"}`} onClick={acsNavMenuClick} >
                           {col.label}
                        </Link>
                     </li>
                  ))}
               </ul>
            </div>
         )}

      </li>
   );
};




const splitIntoColumns = (array: any[], size: number) => {
   const result = [];
   for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
   }
   return result;
};





export default NavMenu